import { render, staticRenderFns } from "./redEnvelopeTemplate.vue?vue&type=template&id=6c4d11a6&scoped=true&"
import script from "./redEnvelopeTemplate.vue?vue&type=script&lang=js&"
export * from "./redEnvelopeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./redEnvelopeTemplate.vue?vue&type=style&index=0&id=6c4d11a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d11a6",
  null
  
)

component.options.__file = "redEnvelopeTemplate.vue"
export default component.exports